import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import 'filepond/dist/filepond.min.css';

import { FilePond, FilePondProps, registerPlugin } from 'react-filepond';
import React, { useEffect, useRef, useState } from 'react';

/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable import/first */
import FilePondPluginFileRename from 'filepond-plugin-file-rename';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
//@ts-ignore
import { translations } from './configurations';
import { useFormikContext } from 'formik';

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);
registerPlugin(FilePondPluginFileRename);

const { REACT_APP_SERVER } = process.env;

// 15MB in bytes
const MAX_FILE_SIZE = 15 * 1024 * 1024;

// Allowed file types
const ALLOWED_FILE_TYPES = [
    'image/jpeg',
    'image/png',
    'image/gif',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
];

export function AttachmentsInput() {
    const [token, setToken] = useState('');
    const filePond = useRef<FilePondProps>();
    const formik = useFormikContext();

    useEffect(() => {
        const load = async () => {
            const token = await localStorage.getItem('token');
            setToken(token || '');
        };
        load();
    }, [setToken]);

    return (
        <div>
            <h4>Завантажте документ(або фото)</h4>
            <div className="App">
                <FilePond
                    //@ts-ignore
                    ref={(ref: any) => {
                        filePond.current = ref;
                    }}
                    allowMultiple={true}
                    maxFiles={5}
                    acceptedFileTypes={ALLOWED_FILE_TYPES}
                    //@ts-ignore
                    maxFileSize={MAX_FILE_SIZE}
                    //@ts-ignore
                    labelMaxFileSize="Максимальний розмір файлу 15MB"
                    //@ts-ignore
                    labelMaxFileSizeExceeded="Файл занадто великий"
                    onupdatefiles={(i) => {
                        formik.setFieldValue(
                            'attachmentIds',
                            //@ts-ignore
                            filePond.current.getFiles().map((element: any) => element.serverId),
                        );
                    }}
                    onprocessfile={(i) =>
                        formik.setFieldValue(
                            'attachmentIds',
                            //@ts-ignore
                            filePond.current.getFiles().map((element: any) => element.serverId),
                        )
                    }
                    server={{
                        process: {
                            url: `${REACT_APP_SERVER}/fileUploader`,
                            withCredentials: true,
                            headers: {
                                authorization: token,
                            },
                        },
                    }}
                    {...translations}
                />
            </div>
        </div>
    );
}
